import { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
    PAGE_PARENT,
    PRESCRIPTION_OPTIONS,
    DATE_FORMAT,
    routeOptions,
    // drugNameOptions,
    frequencyOptions,
    durationOptions,
    infusionOptions,
    additiveListOptions, USER_ROLE, SIDEBAR_ICON
} from "../../common/constant/common-constants";
import { AddPrescription } from "../../components/AddPrescription/AddPrescription";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import { PrescriptionTable } from "../../components/Table/Prescription/PrescriptionTable";
import plusVoiletSvg from "../../common/icons/svg/plus-voilet.svg";
import minusRedSvg from "../../common/icons/svg/minus-red.svg";
import "./PrescriptionContainer.scss";
import DatePicker from "react-date-picker";
import moment from "moment";
import {
    addPrescriptionHelper,
    getPrescriptionHelper,
    updatePrescriptionHelper,
    getDrugNamesHelper,
} from "../../helper/prescription-helper";
import TimePicker from "react-time-picker";

function PrescriptionContainer(props) {


    const [isAddDrugOpen, setIsAddDrugOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(PRESCRIPTION_OPTIONS.DRUGS);
    const [drugName, setDrugName] = useState("");
    const [dosage, setDosage] = useState("");
    const [route, setRoute] = useState("");
    const [frequency, setFrequency] = useState("");
    const [remark, setRemark] = useState("");
    const [infusionName, setInfusionName] = useState("");
    const [volume, setVolume] = useState("");
    const [additive, setAdditive] = useState("");
    const [additiveList, setAdditiveList] = useState([]);
    const [rate, setRate] = useState("");
    const [duration, setDuration] = useState("");
    const [prescriptionDate, setPrescriptionDate] = useState(new Date());
    const [drugData, setDrugData] = useState([]);
    const [infusionData, setInfusionData] = useState([]);
    const [statOrderData, setStatOrderData] = useState([]);
    const [startTime, setStartTime] = useState("");
    const [textDrugName, setTextDrugName] = useState('');
    const [drugNameOptions, setDrugNameOptions] = useState([]);
    const [additiveTextDrug, setAdditiveTextDrug] = useState("");
    const [additiveDrugOptions, setAdditiveDrugOptions] = useState([]);


    useEffect(() => {
        prescriptionDataHandler(selectedOption);
    }, [selectedOption, prescriptionDate])



    useEffect(() => {
        let reqData = {
            name: textDrugName,
        }
        if (textDrugName && textDrugName.length > 0) {
            if ((textDrugName.length % 3) === 0) {
                getDrugNamesHelper(reqData).then((res) => {
                    setDrugArr(res, PRESCRIPTION_OPTIONS.DRUGS);
                }).catch((err) => {
                    console.log("error in helper", err);
                })
            } else {
                let timer1 = setTimeout(() => {
                    getDrugNamesHelper(reqData).then((res) => {
                        setDrugArr(res, PRESCRIPTION_OPTIONS.DRUGS);
                    }).catch((err) => {
                        console.log("error in helper", err);
                    })
                }, 2000);

                return () => {
                    clearTimeout(timer1);
                };
            }
        }
    }, [textDrugName])

    useEffect(() => {
        let reqData = {
            name: additiveTextDrug,
        }
        if (additiveTextDrug && additiveTextDrug.length > 0) {
            if ((additiveTextDrug.length % 3) === 0) {
                getDrugNamesHelper(reqData).then((res) => {
                    setDrugArr(res, PRESCRIPTION_OPTIONS.INFUSION);
                }).catch((err) => {
                    console.log("error in helper", err);
                })
            } else {
                let timer2 = setTimeout(() => {
                    getDrugNamesHelper(reqData).then((res) => {
                        setDrugArr(res, PRESCRIPTION_OPTIONS.INFUSION);
                    }).catch((err) => {
                        console.log("error in helper", err);
                    })
                }, 2000);

                return () => {
                    clearTimeout(timer2);
                };
            }
        }
    }, [additiveTextDrug])



    const setDrugArr = (res, option) => {
        let tempDrugArr = res && res.drugs && res.drugs.map(({ name, salt }, count) => {
            return { name: name, label: `${name} (${salt})`, salt: salt, id: count }
        })
        option === PRESCRIPTION_OPTIONS.DRUGS ? setDrugNameOptions(tempDrugArr) : setAdditiveDrugOptions(tempDrugArr)

    }
    const prescriptionDataHandler = (option) => {
        let reqData = {
            bedId: props.bedId,
            patientSessionId: props.patientSessionId,
            date: moment(prescriptionDate).format(DATE_FORMAT.MOMENT_DATE_FORMAT)
        }

        getPrescriptionHelper(reqData, option).then((data) => {

            if (option === PRESCRIPTION_OPTIONS.DRUGS) setDrugData(data);
            else if (option === PRESCRIPTION_OPTIONS.STAT_ORDERS) setStatOrderData(data);
            else if (option === PRESCRIPTION_OPTIONS.INFUSION) setInfusionData(data);
        }).catch((err) => {
            console.log("err in getting prescription", err);
        })
    }

    const handleAddPrescription = (data) => {
        let reqData = getAddPrescriptionData();

        console.log("prescription req data:: ", reqData);
        addPrescriptionHelper(reqData, selectedOption).then((res) => {

            prescriptionDataHandler(selectedOption);
            console.log(res);
            setDataEmpty();
        }).catch((err) => {
            console.log(err);
        });
    }

    const setDataEmpty = () => {
        setDrugName("");
        setDosage("");
        setRoute("");
        setFrequency("");
        setRemark("");
        setInfusionName("");
        setVolume("");
        setStartTime("");
        setAdditiveList([]);
        setAdditive("");
        setDuration("");
        setRate("");
    }

    const getAddPrescriptionData = () => {
        let reqObj = {
            patientSessionId: props.patientSessionId,
            bedId: props.bedId,
            date: moment(prescriptionDate).format(DATE_FORMAT.MOMENT_DATE_FORMAT)
        }

        if (selectedOption === PRESCRIPTION_OPTIONS.DRUGS) {
            reqObj = {
                ...reqObj,
                name: drugName && (`${drugName.name} (${drugName.salt})`),
                dosage: dosage,
                route: route.name,
                frequency: frequency.name || "",
                startTime: startTime,
                remarks: remark
            }
        } else if (selectedOption === PRESCRIPTION_OPTIONS.STAT_ORDERS) {
            reqObj = {
                ...reqObj,
                name: drugName && (`${drugName.name} (${drugName.salt})`),
                dosage: dosage,
                route: route.name,
                frequency: frequency.name || "",
                startTime: startTime,
                remarks: remark
            }
        } else if (selectedOption === PRESCRIPTION_OPTIONS.INFUSION) {

            let al = additiveList;

            if (additive && dosage) {
                al.push({
                    name: `${additive.name} (${additive.salt})`,
                    dosage: dosage
                });
            }

            reqObj = {
                ...reqObj,
                name: infusionName.name,
                volume: volume,
                additives: al,
                duration: duration.name || "",
                frequency: frequency.name || "",
                startTime: startTime,
                rate: rate,
                remarks: remark
            }
        }

        return reqObj;
    }

    const handleUpdatePrescription = (data) => {

        let reqData = {
            prescriptionId: data.id,
            action: data.action,
            patientSessionId: props.patientSessionId
        }

        console.log(reqData);

        updatePrescriptionHelper(reqData, selectedOption)
            .then((res) => {
                console.log(res);
                prescriptionDataHandler(selectedOption);
            }).catch((err) => {
                console.log(err);
            })
    }

    const handleCancelPrescription = () => {
        setIsAddDrugOpen(false);
    }

    const handleOptionClick = (option) => {
        setDataEmpty();
        setSelectedOption(option);
    }

    const handleAddDrugClick = () => {

        setIsAddDrugOpen(!isAddDrugOpen);
    }

    const getPrescriptionData = () => {

        switch (selectedOption) {
            case PRESCRIPTION_OPTIONS.DRUGS:
                {
                    return drugData;
                }
            case PRESCRIPTION_OPTIONS.INFUSION:
                {
                    return infusionData;
                }
            case PRESCRIPTION_OPTIONS.STAT_ORDERS:
                {
                    return statOrderData;
                }
        }
    }

    const handleAddAdditiveClick = () => {

        if (additive && dosage) {
            let al = additiveList;
            al.push({
                name: `${additive.name} (${additive.salt})`,
                dosage: dosage
            });

            setAdditiveList([...al]);
            setAdditive("");
            setDosage("");
        }
    }

    const handleRemoveAdditiveClick = (additiveName) => {

        let al = additiveList;
        if (al && al.length > 0) {
            let index = -1;
            al.forEach((element, count) => {
                if (element.name === additiveName) index = count;
            });

            al.splice(index, 1);
            setAdditiveList([...al]);
        }
    }

    return (
        <div className="prescription-container">
            <div className="prescription-header-container">
                {props.parent === PAGE_PARENT.PATIENT_MODAL && <div className="prescription-text">
                    Prescription
                </div>}
                {/**  for bed detail page */}
                {props.parent === PAGE_PARENT.BED_DETAIL && <div className="prescription-option-container">
                    <div
                        className={selectedOption === PRESCRIPTION_OPTIONS.DRUGS ?
                            "prescription-option selected-option" : "prescription-option"}
                        onClick={() => handleOptionClick(PRESCRIPTION_OPTIONS.DRUGS)}
                    >{PRESCRIPTION_OPTIONS.DRUGS}</div>
                    <div
                        className={selectedOption === PRESCRIPTION_OPTIONS.INFUSION ?
                            "prescription-option selected-option" : "prescription-option"}
                        onClick={() => handleOptionClick(PRESCRIPTION_OPTIONS.INFUSION)}
                    >{PRESCRIPTION_OPTIONS.INFUSION}</div>
                    <div
                        className={selectedOption === PRESCRIPTION_OPTIONS.STAT_ORDERS ?
                            "prescription-option selected-option" : "prescription-option"}
                        onClick={() => handleOptionClick(PRESCRIPTION_OPTIONS.STAT_ORDERS)}
                    >{PRESCRIPTION_OPTIONS.STAT_ORDERS}</div>
                </div>}
                <div className="date-container">
                    {/* <div className="date-text">Date: </div> */}
                    <DatePicker
                        className="prescription-date"
                        clearIcon={null}
                        onChange={setPrescriptionDate}
                        value={prescriptionDate}
                        openCalendarOnFocus={true}
                        format={DATE_FORMAT.DATEPICKER_DATE_FORMAT}
                    />
                </div>
            </div>
            <div className="prescription-option-container">
                {props.parent === PAGE_PARENT.BED_DETAIL && isAddDrugOpen &&
                    <div className="new-medication-text">New Medication</div>}

                {/*** for homepage modal */}
                {props.parent === PAGE_PARENT.PATIENT_MODAL && <div className="option-container">
                    <div
                        className={selectedOption === PRESCRIPTION_OPTIONS.DRUGS ?
                            "prescription-option selected-option" : "prescription-option"}
                        onClick={() => handleOptionClick(PRESCRIPTION_OPTIONS.DRUGS)}
                    >{PRESCRIPTION_OPTIONS.DRUGS}</div>
                    <div
                        className={selectedOption === PRESCRIPTION_OPTIONS.INFUSION ?
                            "prescription-option selected-option" : "prescription-option"}
                        onClick={() => handleOptionClick(PRESCRIPTION_OPTIONS.INFUSION)}
                    >{PRESCRIPTION_OPTIONS.INFUSION}</div>
                    <div
                        className={selectedOption === PRESCRIPTION_OPTIONS.STAT_ORDERS ?
                            "prescription-option selected-option" : "prescription-option"}
                        onClick={() => handleOptionClick(PRESCRIPTION_OPTIONS.STAT_ORDERS)}
                    >{PRESCRIPTION_OPTIONS.STAT_ORDERS}</div>
                </div>}
                {props.userRole === USER_ROLE.DOCTOR && < div className="add-drug-container">
                    {(!isAddDrugOpen && props.activeSidebarIcon === SIDEBAR_ICON.HOME_PAGE) &&
                        <div className="add-drug-button-container" onClick={() => handleAddDrugClick()}>
                            <div className="add-drug-button">Add Drug</div>
                        </div>}
                    {isAddDrugOpen &&
                        <div className="submit-container">
                            <div
                                className="cancel-button"
                                onClick={() => handleCancelPrescription()}>
                                Cancel
                            </div>
                            <div
                                className="submit-button"
                                onClick={(event) => handleAddPrescription(event.target.value)}>
                                Save
                            </div>
                        </div>}
                </div>}
            </div>
            {
                isAddDrugOpen && <div className="add-prescription-container">
                    {
                        props.parent === PAGE_PARENT.PATIENT_MODAL &&
                        <div className="new-medication-text">New Medication</div>
                    }
                    {(
                        [PRESCRIPTION_OPTIONS.DRUGS, PRESCRIPTION_OPTIONS.STAT_ORDERS]
                            .includes(selectedOption)
                    ) &&
                        <div className="add-prescrition-form drug-form">
                            <div className="drug-name-dosage-route">
                                <div className="drug-name-container">
                                    <label>Drug Name</label>
                                    <CustomSelect
                                        id="drug-name"
                                        handleChange={(item) => setDrugName(item)}
                                        onInputChange={(text) => setTextDrugName(text)}
                                        label='label'
                                        value={drugName}
                                        options={drugNameOptions}
                                        placeholder='Drug Name'
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        className="input-select-class"
                                        fontSize='15px'
                                    />
                                </div>
                                <div className="dosage-container">
                                    <label>Dosage (in mg)</label>
                                    <input
                                        className="prescription-input dosage"
                                        placeholder="Specify the dose in mg"
                                        value={dosage}
                                        onChange={(event) => setDosage(event.target.value)} />
                                </div>
                                <div className="route-container">
                                    <label>Route</label>
                                    <CustomSelect
                                        id="route"
                                        handleChange={(item) => setRoute(item)}
                                        label='label'
                                        value={route}
                                        options={routeOptions}
                                        placeholder='Route'
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        className="input-select-class"
                                    />
                                </div>
                            </div>
                            <div className={`freq-start-time-remarks ${selectedOption === PRESCRIPTION_OPTIONS.STAT_ORDERS ? 'grid-2' : ''}`}>
                                {selectedOption === PRESCRIPTION_OPTIONS.DRUGS && <div className="frequency-container">
                                    <label>Frequency</label>
                                    <CustomSelect
                                        id="frequency"
                                        handleChange={(item) => setFrequency(item)}
                                        label='label'
                                        value={frequency}
                                        options={frequencyOptions}
                                        placeholder='Frequency'
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        className="input-select-class"
                                    />
                                </div>}
                                <div className="start-time-container">
                                    <label>Start Time</label>
                                    <TimePicker
                                        className="start-time-picker"
                                        onChange={(time) => setStartTime(time)}
                                        value={startTime}
                                    />

                                </div>
                                <div className={`remarks-container ${selectedOption === PRESCRIPTION_OPTIONS.STAT_ORDERS ? 'grid-column' : ''}`}>
                                    <label>Special Instructions</label>
                                    <input
                                        className="prescription-input remarks"
                                        placeholder="Special instructions"
                                        value={remark}
                                        onChange={(event) => setRemark(event.target.value)} />
                                </div>
                            </div>
                        </div>}
                    {(selectedOption === PRESCRIPTION_OPTIONS.INFUSION) &&
                        <div className="add-prescrition-form infusion-form">
                            <div className="diluent-vol-container">
                                <div className="infusion-name-container">
                                    <label>Diluent</label>
                                    <CustomSelect
                                        id="infusion-name"
                                        handleChange={(item) => setInfusionName(item)}
                                        options={infusionOptions}
                                        value={infusionName}
                                        placeholder='Diluent name'
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        className="input-select-class"
                                    />
                                </div>
                                <div className="volume-container">
                                    <label>Volume (in ml)</label>
                                    <input
                                        className="prescription-input volume"
                                        placeholder="Specify volume in ml"
                                        value={volume}
                                        onChange={(event) => setVolume(event.target.value)}
                                    />
                                </div>

                            </div>
                            <div className="additive-dosage-adder">
                                {
                                    additiveList && additiveList.map((additiveData) => {
                                        console.log("additive data", additiveData);
                                        return <>
                                            <div className="additive-container" key={additiveData.name}>
                                                <label>Drug</label>
                                                <input
                                                    className="prescription-input additive-name"
                                                    value={additiveData.name}
                                                    placeholder='Drug'
                                                    readOnly
                                                />
                                            </div>
                                            <div className="infusion-dosage-container">
                                                <label>Infusion Dosage (in mg)</label>
                                                <input
                                                    className="prescription-input infusion-dosage"
                                                    placeholder="Dosage (mg)"
                                                    value={additiveData.dosage}
                                                    readOnly
                                                // onChange={(event) => setDosage(event.target.value)} 
                                                />
                                            </div>
                                            <div className="remove-additive-container" onClick={() => handleRemoveAdditiveClick(additiveData.name)}>
                                                <img src={minusRedSvg} className="remove-icon" />
                                            </div>
                                        </>
                                    })
                                }
                                <div className="additive-container">
                                    <label>Drug</label>
                                    <CustomSelect
                                        id="additive"
                                        fontSize='15px'
                                        handleChange={(item) => setAdditive(item)}
                                        onInputChange={(text) => setAdditiveTextDrug(text)}
                                        value={additive}
                                        options={additiveDrugOptions}
                                        placeholder='Drug'
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        className="input-select-class"
                                    />
                                </div>
                                <div className="infusion-dosage-container">
                                    <label>Infusion Dosage (in mg)</label>
                                    <input
                                        className="prescription-input infusion-dosage"
                                        value={dosage}
                                        placeholder="Dosage (mg)"
                                        onChange={(event) => setDosage(event.target.value)} />
                                </div>
                                <div className="add-additive-container" onClick={() => handleAddAdditiveClick()}>
                                    <img src={plusVoiletSvg} className="add-icon" />
                                    <div className="add-additive-text">Drug</div>
                                </div>
                            </div>
                            <div className="rate-duration-start-time">
                                <div className="rate-container">
                                    <label >Rate</label>
                                    <input
                                        className="prescription-input rate"
                                        value={rate}
                                        placeholder="Specify rate in ml/hr"
                                        onChange={(event) => setRate(event.target.value)}
                                    />
                                    {/* <CustomSelect
                            id="rate"
                            handleChange={(item) => setRate(item.name)}
                            // label='Volume'
                            options={[{ name: 'Rate-1', label: 'Rate 1' }, { name: 'Rate-2', label: 'Rate 2' }]}
                            placeholder='Rate'
                            components={{
                                IndicatorSeparator: () => null
                            }}
                        /> */}
                                </div>
                                <div className="duration-container">
                                    <label>Duration</label>
                                    <CustomSelect
                                        id="duration"
                                        handleChange={(item) => setDuration(item)}
                                        value={duration}
                                        // label='Volume'
                                        options={durationOptions}
                                        placeholder='Duration'
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        className="input-select-class"
                                    />
                                </div>
                                {/* <div className="frequency-container">
                            <label >Frequency</label>
                            <CustomSelect
                                id="frequency"
                                handleChange={(item) => setFrequency(item)}
                                value={frequency}
                                options={frequencyOptions}
                                placeholder='Frequency'
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                                className="input-select-class"
                            />
                        </div> */}
                                <div className="start-time-container">
                                    <label>Start Time</label>
                                    <TimePicker
                                        className="start-time-picker"
                                        onChange={(time) => setStartTime(time)}
                                        value={startTime}
                                    />

                                </div>
                            </div>
                            <div className="infusion-remarks-container">
                                <label>Special Instructions</label>
                                <input
                                    className="prescription-input infusion-remarks"
                                    placeholder="Special instructions"
                                    value={remark}
                                    onChange={(event) => setRemark(event.target.value)} />
                            </div>
                        </div>}
                </div>
            }
            <div className="prescription-history-table">
                <PrescriptionTable
                    data={getPrescriptionData()}
                    date={prescriptionDate}
                    type={selectedOption}
                    handleUpdatePrescription={(data) => handleUpdatePrescription(data)} />
            </div>
        </div >)
}

const mapStateToProps = (state, ownProps) => {

    let patientSessionId = state.patientDataReducer.patientData
        && state.patientDataReducer.patientData[ownProps.bedId]
        && state.patientDataReducer.patientData[ownProps.bedId].sessionId;
    let userRole = state.userDataReducer && state.userDataReducer.userRole;


    return {
        patientSessionId: patientSessionId,
        config: state.configReducer.config,
        userRole: userRole,
        activeSidebarIcon: state.configReducer.config.activeSidebarIcon,
    };
};

export default connect(mapStateToProps, null)(PrescriptionContainer);